var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "#B9B9B9",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.12 11.056C21.704 11.056 22.984 11.504 23.96 12.4C24.936 13.296 25.424 14.496 25.424 16C25.424 17.68 24.904 18.928 23.864 19.744C22.824 20.544 21.416 20.944 19.64 20.944L19.568 23.224H17.672L17.576 19.432H18.272C19.856 19.432 21.096 19.192 21.992 18.712C22.888 18.232 23.336 17.328 23.336 16C23.336 15.04 23.048 14.28 22.472 13.72C21.896 13.16 21.12 12.88 20.144 12.88C19.152 12.88 18.368 13.152 17.792 13.696C17.232 14.224 16.952 14.952 16.952 15.88H14.888C14.888 14.92 15.104 14.08 15.536 13.36C15.968 12.624 16.576 12.056 17.36 11.656C18.16 11.256 19.08 11.056 20.12 11.056ZM18.608 28.144C18.192 28.144 17.84 28 17.552 27.712C17.264 27.424 17.12 27.072 17.12 26.656C17.12 26.24 17.264 25.888 17.552 25.6C17.84 25.312 18.192 25.168 18.608 25.168C19.008 25.168 19.344 25.312 19.616 25.6C19.904 25.888 20.048 26.24 20.048 26.656C20.048 27.072 19.904 27.424 19.616 27.712C19.344 28 19.008 28.144 18.608 28.144Z",
    fill: "#AAA7A7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#AAA7A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question-mark.a88f7390f7e83ea61b146e29ab929e07.svg";
export { ForwardRef as ReactComponent };